module.exports = __webpack_public_path__ + "static/media/capa-jacoby.806e645b.png";